module.exports = __webpack_public_path__ + "static/8-29024d2f7a8325da31852b9d86e01e64.jpg";